export interface AuthTokens {
	accessToken: string;
	accessTokenExpiration: string;
	refreshToken: string;
	refreshTokenExpiration: string;
}

const TOKENS_STORAGE_KEY = 'auth_tokens';

export function saveTokens(tokens: AuthTokens): void {
	localStorage.setItem(TOKENS_STORAGE_KEY, JSON.stringify(tokens));
}

export function getTokens(): AuthTokens | null {
	const stored = localStorage.getItem(TOKENS_STORAGE_KEY);

	if (!stored) return null;

	try {
		return JSON.parse(stored) as AuthTokens;
	} catch {
		return null;
	}
}

export function clearTokens(): void {
	localStorage.removeItem(TOKENS_STORAGE_KEY);
}

export function isAccessTokenExpired(tokens: AuthTokens | null): boolean {
	if (!tokens) return true;

	const expirationTime = new Date(tokens.accessTokenExpiration).getTime();
	const now = Date.now();
	const buffer = 60 * 1000; // 1 minute buffer

	return now >= expirationTime - buffer;
}

export function isRefreshTokenExpired(tokens: AuthTokens | null): boolean {
	if (!tokens) return true;

	const expirationTime = new Date(tokens.refreshTokenExpiration).getTime();
	const now = Date.now();

	return now >= expirationTime;
}

export function hasJwtSession(): boolean {
	const tokens = getTokens();

	return !!(tokens && !isRefreshTokenExpired(tokens));
}

export function isLoggedIn(): boolean {
	// TODO: rewrite this to real handler, it's just for testing while BE is not implemented
	return true;
}
